__turbopack_context__.v({
  "center": "index-module__bpCN6q__center",
  "closeIcon": "index-module__bpCN6q__closeIcon",
  "container": "index-module__bpCN6q__container",
  "dropdownContainer": "index-module__bpCN6q__dropdownContainer",
  "header": "index-module__bpCN6q__header",
  "infoBanner": "index-module__bpCN6q__infoBanner",
  "left": "index-module__bpCN6q__left",
  "logo": "index-module__bpCN6q__logo",
  "progressContainer": "index-module__bpCN6q__progressContainer",
  "progressFloater": "index-module__bpCN6q__progressFloater",
  "right": "index-module__bpCN6q__right",
  "saveButton": "index-module__bpCN6q__saveButton",
});
